<template>
<div>

  <!-- products -->

  <div v-for="item of items[0].subcategorias" :key="item.id" class="container-fluid my-5 px-md-5">
    <div class=" mt-2 mb-2 mx-md-4">
      <div class="title " data-aos="fade-down">
        {{item.titulo}}
      </div>
      <!-- <p class="" data-aos="fade-up" data-aos-duration="500">{{item.descripcion}}</p> -->
    </div>
    <div class="inner only-this-horizon-scrollbar" style="">
      <div class="scroll-container diff-size " >
        <div class="scroll-section " v-for="el of item.tarjetas" :key="el.id">
            <product-vue :product="el" class="zoom" />
        </div>
      </div>
    </div>
    
  </div>
  



</div>
</template>

<script>
import carousel from "../../components/carousel.vue";
import ProductVue from "../../components/Product.vue";
import CardImg from "../../components/Card-img.vue";
import ProductDetailVue from "../../components/ProductDetail.vue";
import contact from '../../components/Contact.vue'


export default {
  components: { ProductVue, ProductDetailVue, carousel, CardImg, contact },
  data() {
    return {
      slide: 0,
      sliding: null,
      categories: [],
      productData: {},
      storeId: 0,
      productSearch: null,

      products: [],

      offerProducts: [],
      card_crucero:[
        {id:1, 
       titulo: "Crucero por el mar mediterraneo", 
        descripcion:"Amet minim mollit non deserunt ullamco.", 
        img: '../img/card_.png',
        textoboton: 'Ver detalles'
        },
        {id:2, 
        titulo: "Crucero por el mar mediterraneo", 
        descripcion:"Amet minim mollit non deserunt ullamco.", 
        img: '../img/card_.png',
        textoboton: 'Ver detalles'
        },
        {id:3, 
        titulo: "Crucero por el mar mediterraneo", 
        descripcion:"Amet minim mollit non deserunt ullamco.", 
        img: '../img/card_.png',
        textoboton: 'Ver detalles'
        },
        {id:4, 
        titulo: "Crucero por el mar mediterraneo", 
        descripcion:"Amet minim mollit non deserunt ullamco.", 
        img: '../img/card_.png',
        textoboton: 'Ver detalles'
        },
        {id:5, 
        titulo: "Crucero por el mar mediterraneo", 
        descripcion:"Amet minim mollit non deserunt ullamco.", 
        img: '../img/card_.png',
        textoboton: 'Ver detalles'
        },
        {id:6, 
        titulo: "Crucero por el mar mediterraneo", 
        descripcion:"Amet minim mollit non deserunt ullamco.", 
        img: '../img/card_.png',
        textoboton: 'Ver detalles'
        },
        {id:7, 
        titulo: "Circuitos", 
        descripcion:"Amet minim mollit non deserunt ullamco.", 
        img: '../img/card_.png',
        textoboton: 'Ver detalles'
        },
        {id:8, 
        titulo: "Crucero por el mar mediterraneo", 
        descripcion:"Amet minim mollit non deserunt ullamco.", 
        img: '../img/card_.png',
        textoboton: 'Ver detalles'
        },
        {id:9, 
        titulo: "Crucero por el mar mediterraneo", 
        descripcion:"Amet minim mollit non deserunt ullamco.", 
        img: '../img/card_.png',
        textoboton: 'Ver detalles'
        },
        {id:10, 
        titulo: "Crucero por el mar mediterraneo", 
        descripcion:"Amet minim mollit non deserunt ullamco.", 
        img: '../img/card_.png',
        textoboton: 'Ver detalles'
        },
               
        
      ],
      card_img:[
        {id: 1, 
        titulo: "Luxury Collection", 
        descripcion:"Amet minim mollit non deserunt ullamco.", 
        textoboton: "Ver mas", 
        columnas: 12, 
        img: '../img/Banner_2.png',
        posicionpanel: 'arriba', 
        columnaspanel:6,
        width: '480',
        height: '370',
        // alturapanel: 170,
        ruta: '/luxury',
        panelhorizontal: 0,
        izquierda: 6,
        },
        {id:2, 
        titulo: "Circuitos", 
        descripcion:"Amet minim mollit non deserunt ullamco.", 
        textoboton: "Ver mas", 
        columnas: 7 , 
        img: '../img/Banner.png',
        posicionpanel: 370, 
        columnaspanel:10 ,
        width: '930',
        height: '370',
        izquierda: 0,
        alturapanel: 170,
        ruta: '/circuitos',
        },
        
        {id: 3, 
        col_text: 7,
        col_button: 4,
        titulo: "Hoteles", 
        descripcion:"Amet minim mollit non deserunt ullamco.", 
        textoboton: "Ver mas", 
        columnas: 5, 
        img: '../img/Banner_1.png',
        posicionpanel: 'arriba', 
        
        columnaspanel: 12,
        width: '480',
        height: '370',
        
        panelhorizontal: 1,
        ruta: '/hotel',
        },
        {id: 4, 
        titulo: "Parques", 
        descripcion:"Amet minim mollit non deserunt ullamco.", 
        textoboton: "Ver mas", 
        columnas: 5, 
        img: '../img/banner4.png',
        posicionpanel: 'arriba', 
        columnaspanel:12,
        width: '480',
        height: '370',
        alturapanel: 210,
        posicionpanel: 370, 
        panelhorizontal: 1,
        col_text: 7,
        col_button: 4,
        ruta: '/parques',
        },
        {id:5, 
        titulo: "Promociones y recursos para agentes de viaje", 
        descripcion:"Accede a promociones, ofertas y precios exclusivos para agentes de viaje.", 
        textoboton: "Ver mas", 
        columnas: 7 , 
        img: '../img/Banner_3.png',
        posicionpanel: 370, 
        columnaspanel:10 ,
        width: '930',
        height: '370',
        izquierda: 2,
        ruta: '/',
        alturapanel: 200,
        
        },
        
        
      ],
      card_img2:[
        {id:1, 
        titulo: "Crucero por el caribe", 
        descripcion:"Desde 1,400 USD", 
        textoboton: "Ver mas", 
        columnas: 12 , 
        img: '../img/Banner2.png',
        posicionpanel: 370, 
        columnaspanel:7 ,
        panelhorizontal:1,
        width: '930',
        height: '370',
        izquierda: 0,
        alturapanel: 110,
        col_text: 7,
        col_button: 4,
        
        },
      ],
      /////////
      categoria_id: 6,
      table: 'categorias',
      items: [],
      rutaCategoria: 'naotools',
      categorias:[],
      itemCategoria:{}
    };
  },
  async mounted() {
    this.$isLoading(true)
    await this.getData()
    // await this.getCarousel()
    // await this.getCategorias()
    this.$isLoading(false)

  },
  methods: {
    goto(url){
      if(url.includes('http')){
        console.log('web', url)
        window.open(url)
      }
      else{
        window.location.href =url
        console.log('in', url)
      }      
    },
    async getCategorias() {
      try {
        let res = await this.$store.dispatch("get", { path: 'categorias/getAll/'});
        console.log(res)
        if(res.length>0){
          this.itemCategoria = res.filter((x) => x.id == this.categoria_id)
          this.itemCategoria = this.itemCategoria[0]
          console.log('******************************* item categoria', this.itemCategoria)
          //return
          //this.categorias = await res
          // let categorias = res.filter((x) => x.nombre != 'Cruceros' && x.nombre != 'Otros' && x.nombre != 'deals')
          let categorias = res.filter((x) => x.orden_cruceros >0 )
          //console.log('------>',res)
          for await (let it of categorias){
            for await (let el of this.card_img){
              if(it.orden_cruceros === el.id){
                it.textoboton = el.textoboton
                it.columnas = el.columnas
                it.posicionpanel = el.posicionpanel
                it.columnaspanel = el.columnaspanel
                it.width = el.width
                it.height = el.height
                it.izquierda = el.izquierda
                it.alturapanel = el.alturapanel
                it.ruta = el.ruta
                it.orden = el.id
              }
            }
          }
           this.categorias = categorias.sort(function(a,b){
            return a.orden - b.orden
          } )
          console.log('categorias ordenadas---->',this.categorias)
        }
        else{
          this.categorias = []
        }
      } catch (error) {
        console.log(error)
        this.categorias = []
        this.$swal({
          icon: "error",
          title: "Oopss!",
          text: "Error: " + error,
        });
      }
    },
    async getCarousel() {
      try {
        let res = await this.$store.dispatch("get", { path: '/categorias_carousel/getAllByCategory/' + this.categoria_id});
        if(res.length>0){
          this.card_img2= []
          for await (let it of res){
            let data = {
              textoboton:it.texto_boton,
              columnas: 12 ,
              urlimagen : it.urlimagen,
              posicionpanel: 370,
              columnaspanel:7,
              panelhorizontal:1,
              width: '930',
              height: '370',
              izquierda: 0,
              alturapanel: 110,
              col_text: 7,
              col_button: 4,
              titulo: it.titulo,
              descripcion: it.descripcion,
              ruta: it.ruta_boton
            }
          this.card_img2.push(data)
          }
        }
        else{
          this.card_img2 = []
        }
      } catch (error) {
        this.card_img2 = []
        throw error;
      }
    },
    async getData() {
      try {
        let res = await this.$store.dispatch("get", { path: this.table + '/getAllByCategory/' + this.categoria_id});
        console.log('********',res)
        if(res.length>0){
          for await(let it of res[0].subcategorias){
            console.log(it)
            for await(let ele of it.tarjetas){
              console.log(ele)
              ele.ruta = ele.documento_word //'/detalle/'+ this.rutaCategoria + '/' + ele.id

            }
          }
          this.items = res
        }
        else{
          this.items = []
        }
      } catch (error) {
        console.log('errr ',error);
        this.items = []
      }
    },

    ///////////////
    sendMessage(){
      alert('Mensaje enviado correctamente!')
    },    
    goSearch() {
      localStorage.setItem("search", this.productSearch);
      this.$router.push("store/0");
    },
    gotoStore(category) {
      this.$router.push("store/" + category);
    },
    async getProducts() {
      try {
        this.storeId = localStorage.getItem("storeId");
        this.products = await this.$store.dispatch(
          "getAll",
          "newProductsByStore/" + this.storeId
        );
      } catch (error) {
        throw error;
      }
    },
    async productsOffer() {
      try {
        this.storeId = localStorage.getItem("storeId");
        this.offerProducts = await this.$store.dispatch(
          "getAll",
          "productsOffer/" + this.storeId
        );
        if(this.offerProducts){
          this.offerProducts = this.offerProducts.filter(x => x.variations.length>0);
        }
      } catch (error) {
        throw error;
      }
    },
    // showProductDetail(item) {
    //   item["quantity"] = 1;
    //   this.productData = item;
    //   this.$bvModal.show("modal-productDetail");
    // },
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
    showModal() {
      this.$bvModal.show("modal-chooseStore");
    },
    closeModal() {
      this.$bvModal.hide("modal-chooseStore");
      this.$bvModal.hide("modal-productDetail");
    },
  },
};
</script>
<style scoped>

.inner {
  max-width: 100%;
  margin: auto;
  padding-left: 15px;
  padding-right: 15px;
}
.scroll-container {
  position: relative;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  width: 100%;
  
  scroll-snap-type: mandatory;
  scroll-behavior: smooth;
  
  word-wrap: break-word !important; 
  margin-bottom: 50px;
}

.scroll-container .scroll-section {
  display: inline-block;
  vertical-align: middle;
  
  /* white-space: nowrap; */
}
/*Slider X (different sized images)*/

.scroll-container.diff-size {
  scroll-snap-destination: 50% 0%;
  padding: 20px 0px;
  margin: 1%;
}

.scroll-container.diff-size .scroll-section {
  width: auto;
  height: 100%;
  margin-right: 15px;
  scroll-snap-coordinate: 50% 0%;
}

.scroll-container.diff-size .scroll-section:first-child {
  scroll-snap-coordinate: 0% 0%, 50% 0%;
  margin-left: 15px;
}

.scroll-container.diff-size .scroll-section:last-child {
  scroll-snap-coordinate: 50% 0%, 100% 0%;
}
.card-div{
  
  height:auto !important;
  width:264px !important;
  
}
.searchdiv {
  /* background-color:#fd306e !important; */
  /* background-color: black !important; */
  /* padding: 30px;
  box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.25);
  border-radius: 20px; */
}
.buttonsearch {
  background-color: #fd306e !important;
  color: white;
}
.inputSearch {
  border-color: #fd306e !important;
}

.carousel-item img {
  /* height:100vh!important ; */
}

 
</style>